import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Makes palette block types draggable clones that can be dropped into the timeline.
// Works in tandem with compose_timeline_controller's SortableJS group.
export default class extends Controller {
  static targets = ["list"]
  static values = { baseUrl: String }

  connect() {
    if (!this.hasListTarget) return

    this.sortables = this.listTargets.map(list =>
      Sortable.create(list, {
        group: { name: "palette", pull: "clone", put: false },
        sort: false,
        ghostClass: "opacity-30",
        filter: "form",
        onEnd: this.handleDrop.bind(this)
      })
    )
  }

  disconnect() {
    this.sortables?.forEach(s => s.destroy())
    this.sortables = null
  }

  handleDrop(event) {
    // If dropped back into any palette list, ignore
    if (this.listTargets.includes(event.to)) return

    // Clone gets cleaned up by timeline controller
  }
}
